/**
 * ModuleCreatureAnimState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleCreatureAnimState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleCreatureAnimState {
  IDLE = 10000,
  ANIMATING = 4,
  //CREATURE
  PAUSE = 10000,


  //READY - depends on equipped weapons
  //1=92,2=133,3=174,4=215,5=223,6=237,7=245,8=249,9=245
  READY = 10001,


  //WALK - depends on equipped weapons
  //2=338,3=341,4=339,5=0,6=0,7=340,8=0,9=340 simple 253
  WALKING = 10002,


  //WALKING_BACK - depends on equipped weapons
  //2=338,3=341,4=339,5=0,6=0,7=340,8=0,9=340 simple 253
  WALKING_BACK = 10003,
  RUNNING = 10004,
  DEAD = 10006,
  DEAD1 = 10008,
  ATTACK = 10009,
  DODGE = 10011,
  PARRY = 10012,
  DAMAGE = 10014,
  CASTOUT1 = 10015,
  CASTOUT2 = 10016,
  CASTOUT1_LP = 10017,
  CASTOUT2_LP = 10018,
  SPASM = 10023,
  TAUNT = 10028,
  GREETING = 10029,
  LISTEN = 10030,
  MEDITATE = 10032,
  WORSHIP = 10033,
  SALUTE = 10034,
  BOW = 10035,
  TALK_NORMAL = 10038,
  TALK_PLEADING = 10039,
  TALK_FORCEFUL = 10040,
  TALK_LAUGHING = 10041,
  TALK_SAD = 10042,
  VICTORY = 10044,
  PAUSE2 = 10052,
  HEAD_TURN_LEFT = 10053,
  HEAD_TURN_RIGHT = 10054,
  TURN_LEFT = 10509, /** Value Not Confirmed */
  TURN_RIGHT = 10510, /** Value Not Confirmed */
  PAUSE_SCRATCH_HEAD = 10055,
  PAUSE_BORED = 10056,
  PAUSE_TIRED = 10057,
  PAUSE_DRUNK = 10058,
  GET_LOW = 10059,
  GET_MID = 10060,
  THROW_SABER_LP = 10061,
  INJECT = 10070,
  DAMAGE2 = 10077,
  PAUSE_INJ = 10092,
  WALK_INJ = 10093,
  RUN_INJ = 10094,
  ATTACK_DUELING = 10109,
  USE_COMPUTER_LP = 10112,
  WHIRLWIND = 10117,
  DEACTIVATE = 10118,
  FLIRT = 10120,
  USE_COMPUTER = 10121,
  DANCE = 10122,
  DANCE1 = 10123,
  HORROR = 10124,
  USE_COMPUTER2 = 10125,
  PERSUADE = 10126,
  ACTIVATE_ITEM = 10127,
  UNLOCK_DOOR = 10128,
  THROW_HIGH = 10129,
  THROW_LOW = 10130,
  UNLOCK_CONTAINER = 10131,
  DISABLE_MINE = 10132,
  WALK_STEALTH = 10133,
  UNLOCK_DOOR2 = 10134,
  UNLOCK_CONTAINER2 = 10135,
  ACTIVATE_ITEM2 = 10136,
  SLEEP = 10137,
  PARALYZED = 10138,
  PRONE = 10139,
  SET_MINE = 10140,
  DISABLE_MINE2 = 10141,
  CUSTOM01 = 10142,
  FBLOCK = 10145,
  PAUSE4 = 10147,


  //READY_ALT - depends on equipped weapons
  //1=92,2=133,3=174,4=215,5=223,6=237,7=245,8=249,9=245
  READY_ALT = 10148,
  PAUSE_ALT = 10149,
  CHOKE = 10150,
  PAUSE3 = 10151,
  WELD = 10152,
  TALK_INJURED = 10154,
  LISTEN_INJURED = 10155,
  DEAD_PRONE = 10156,


  //MELEE_WIELD - depends on equipped weapons
  //1=378,2=377,3=378,4=376,5=378,6=378,7=378,8=378,9=378
  MELEE_WIELD = 10157,


  //MELEE_COMBAT_WIELD - depends on equipped weapons
  //2=132,3=214,4=173
  MELEE_COMBAT_WIELD = 10158,
  TREAT_INJURED = 10159,
  TREAT_INJURED_LP = 10160,
  CATCH_SABER = 10161,
  THROW_SABER = 10162,
  KID_TALK_ANGRY = 10163,
  KID_TALK_SAD = 10164,
  KNOCKED_DOWN = 10219,
  KNOCKED_DOWN2 = 10220,
  DIE = 10221,
  DIE1 = 10222,
  GET_UP_DEAD = 10223,
  GET_UP_DEAD1 = 10224,
  KNEEL = 10237,
  KNEEL1 = 10238,


  //FLOURISH - depends on equipped weapons
  //1=91,2=132,3=173,4=214,5=222,6=136,7=244,8=373,9=244
  FLOURISH = 10246,
  KNEELING = 10271,


  //DAMAGED - depends on equipped weapons
  //1=unknown,2=124,3=206,4=165,5=220,6=234,7=242,8=280,9=242
  DAMAGED = 10302,


  //BLASTER_DEFLECTION_1H - depends on equipped weapons
  //2=109,3=151,4=192
  BLASTER_DEFLECTION_1H = 10300,


  //BLASTER_DEFLECTION_2H - depends on equipped weapons
  //2=110,3=151,4=192
  BLASTER_DEFLECTION_2H = 10301,
  KNOCKED_DOWN_LP = 10400,
  POWER_ATTACK_SS = 10401,
  KNOCKED_DOWN2_LP = 10402,



  //BEGIN TSL ANIMATIONS
  TOUCH_HEART = 10403,
  ROLL_EYES = 10404,
  USE_ITEM_ON_OTHER = 10405,
  STAND_ATTENTION = 10406,
  NOD_YES = 10407,
  NOD_NO = 10408,
  POINT = 10409,
  POINT_LP = 10410,
  POINT_DOWN = 10411,
  SCANNING = 10412,
  SHRUG = 10413,
  SIT_CHAIR = 10424,
  SIT_CHAIR_DRUNK = 10425,
  SIT_CHAIR_PAZAAK = 10426,
  SIT_CHAIR_COMP1 = 10427,
  SIT_CHAIR_COMP2 = 10428,
  CUT_HANDS = 10499,
  L_HAND_CHOP = 10500,
  COLLAPSE = 10501,
  COLLAPSE_STAND = 10503,
  BAO_DUR_POWER_PUNCH = 10504,
  HOOD_OFF = 10507,
  HOOD_ON = 10508,

  //END TSL ANIMATIONS
  CASTOUT3 = 11000,
  CRITICAL_STRIKE2_SS = 11001,
  CRITICAL_STRIKE3_SS = 11002,
  
  KNEEL_TALK_ANGRY,
  KNEEL_TALK_SAD,
  COLLAPSE_LP,
  POINT_UP,
  POINT_UP_LOWER,
  DIVE_ROLL
};